/**
* this displays the fund members contribution details
*
* Created by Paul on 29/05/19
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import cx from 'classnames'
import { connect } from 'react-redux'
import moment from 'moment'
import NumberFormat from 'react-number-format'

// action import
import { ActionCreator } from '../../actions/'

// Configurations
import constants from '../../constants'
import config from '../../config'

// material-ui import
import { withStyles, makeStyles } from '@material-ui/styles'
import Typography from '@material-ui/core/Typography'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import Divider from '@material-ui/core/Divider'

import { MdWarning } from "react-icons/md"
import Tooltip from '@material-ui/core/Tooltip';

// style import
import './style.scss'

const styles = theme => ({
    gridroot: {
        flexGrow: 1,
    },
    card: {
        height: '100%',
    },
    title: {
        fontSize: 16,
    },
    pos: {
        marginBottom: 12,
    },
    card_body: {
        fontSize: 13,
    },
    list_root: {
        width: '100%',
    },
    list_paper: {
        width: '100%',
        overflowX: 'auto',
        boxShadow: 'none',
        marginTop: 20,
    },
    list_table: {
        /*minWidth: 450,*/
    },
    icon: {
        marginTop: -4,
        marginLeft: 0,
        fontSize: 21,
    },
    table_header_cell: {
        fontWeight: 'bold',
        fontOpacity: 1,
        fontSize: 13,
        paddingLeft: 1,
        '&:last-child': {
            paddingRight: 1,
        },
        color: 'rgba(0, 0, 0, 0.75)',
    },
    table_cell: {
        paddingLeft: 1,
        '&:last-child': {
            paddingRight: 1,
        }
    },
    table_summary_cell: {
        paddingLeft: 1,
        fontWeight: 'bold',
        '&:last-child': {
            paddingRight: 1,
        },
        color: 'rgba(0, 0, 0, 0.75)',
    },
    table_cell_no_border: {
        borderBottom: '1px solid #fff',
    },
    notesTitle: {
        fontWeight: 500,
    },
})

class FundContributions extends Component {

	componentDidMount() {
        const { getFundContributions, member_id } = this.props
        getFundContributions(member_id)
    }

    renderMember(member, index, year, memberCount) {
        
        const { classes, fundSummary } = this.props
        let ageString = 'Age ' + member.age + ' (at 30th June ' + year + ')'

        return (
            <React.Fragment key={ index }>
                <Typography className={classes.title} variant="h5" component="h2">
                    { member.name }
                </Typography>

                <Typography variant="body1" color="textSecondary" component="p">
                    { ageString } {/* member.status */}
                </Typography>

                <Typography variant="body2" color="textSecondary" component="p" gutterBottom>
                    { member.status }
                </Typography>

                <div className={classes.list_root}>
                    <Paper className={classes.list_paper}>
                        <Table className={classes.list_table} size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={ classes.table_header_cell }>Type</TableCell>
                                    <TableCell className={ classes.table_header_cell }>Notes</TableCell>
                                    <TableCell align="right" className={ classes.table_header_cell }>Concessional</TableCell>
                                    <TableCell align="right" className={ classes.table_header_cell }>Non-Concessional</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { member.breakdowns.map((row, index) => (
                                    row.type === 'Available' ? (
                                        <TableRow key={ index }>
                                            <TableCell rowSpan={2} className={ classes.table_cell_no_border } />
                                            <TableCell className={ classes.table_summary_cell }>{ row.type }</TableCell>
                                            <TableCell align="right" className={ classes.table_summary_cell }><NumberFormat value={ row.concessional } displayType={'text'} thousandSeparator={true} prefix={'$'} /></TableCell>
                                            <TableCell align="right" className={ classes.table_summary_cell }><NumberFormat value={ row.nonConcessional } displayType={'text'} thousandSeparator={true} prefix={'$'} /></TableCell>
                                        </TableRow>
                                    ) : (
                                        <TableRow key={ index }>
                                            <TableCell component="th" scope="row" className={ classes.table_cell }>{ row.type }</TableCell>
                                            <TableCell className={ classes.table_cell }>{ row.footNoteNumbers }</TableCell>
                                            <TableCell align="right" className={ classes.table_cell }><NumberFormat value={ row.concessional } displayType={'text'} thousandSeparator={true} prefix={'$'} /></TableCell>
                                            <TableCell align="right" className={ classes.table_cell }><NumberFormat value={ row.nonConcessional } displayType={'text'} thousandSeparator={true} prefix={'$'} /></TableCell>
                                        </TableRow>
                                    )
                                ))}
                            </TableBody>
                        </Table>
                    </Paper>
                </div>

                <Typography variant="subtitle2">
                    Notes:
                </Typography>

                <ol>
                    { member.breakdowns.map(row => (
                        row.notes.map((note, index) => (
                            <li key={ index }>
                                <Typography variant="caption">
                                    {note.number}: { note.note }
                                </Typography>
                            </li>
                        ))
                    ))}
                </ol>

                { (index + 1 < memberCount) && <Divider style={{margin:40}} /> }

            </React.Fragment>
        )
    }

    render() {

        const { classes, fundContributionsData, fundSummary } = this.props

        const year = new Date().getFullYear()
        const reportURL = config.endpoints.downloadContributionReportURL + fundSummary.fund_code + '/' + year + '/'

        let members = []
        if (fundContributionsData.members)
            members = fundContributionsData.members

        return (
            <ExpansionPanelDetails>

                { members.length === 0 ? (
                    <Typography>There is currently no contribution data available.</Typography>
                ) : (

                    <div className={classes.gridroot}>
                        <Grid container spacing={3}>

                            <Grid item xs={12}>
                                <Card className={classes.card}>
                                    <CardContent>
                                        { members.map(
                                            (member,index)=>{return this.renderMember(member, index, year, members.length)}
                                        )}
                                    </CardContent>
                                    <CardActions>
                                        <Button size="small" href={ reportURL } target="_blank">Download Full Contribution Report</Button>
                                    </CardActions>
                                </Card>
                            </Grid>

                        </Grid>
                    </div>
                )}
                
            </ExpansionPanelDetails>
        )
    }
}

// define the prop types
FundContributions.propTypes = {
    classes: PropTypes.object.isRequired,
    isFundContributionsLoading: PropTypes.bool,
    fundContributionsData: PropTypes.object,
}

const mapStateToPros = (state) => {
    return {
        isFundContributionsLoading: state.fundState.isFundContributionsLoading,
        fundContributionsData: state.fundState.fundContributionsData,
        fundSummary: state.fundState.fundSummary,
    }
}

const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
    	getFundContributions: action.getFundContributions,
    }
}

export default connect(mapStateToPros,mapDispatchToProps)(withStyles(styles)(FundContributions))


// WEBPACK FOOTER //
// ./src/components/FundContributions/index.js